
const useEnvironment = () => {
    
    const url = window.location.href;
    const { hostname } = new URL(url);
    
    /** local, develop, staging, production */
    const isEnvironment = (envValue) => {
        if (
            (envValue === "local" && hostname === "localhost") ||
            (envValue === "develop" && hostname === "employer-dev.earnipay.com") ||
            (envValue === "staging" && hostname === "employer-stg.earnipay.com") ||
            (envValue === "production" && hostname === "employer.earnipay.com")
        ){
            return true;
        }
        return false;
    }
    
    return {isEnvironment};
}


export default useEnvironment;
